import type { JSX } from 'react';
import { isNonEmptyRecord } from '~/utilities/type-guards';
import type { EmbedOptions } from '~/playerEmbedOptions/types';
import type { DownloadableMediaFile } from '../DownloadsTable/DownloadsTable';
import { ThumbnailDownloadRow } from './ThumbnailDownloadRow';
import { StoryboardDownloadRow } from './StoryboardDownloadRow';
import { SelectWrapper } from './SharedStyledComponents';

type Props = {
  storyboard: DownloadableMediaFile;
  thumbnail: DownloadableMediaFile;
  embedOptions: EmbedOptions;
};

export const ThumbnailTab = ({ storyboard, thumbnail, embedOptions }: Props): JSX.Element => {
  return (
    <SelectWrapper>
      <ThumbnailDownloadRow
        thumbnail={thumbnail}
        embedOptions={embedOptions}
      />
      {isNonEmptyRecord(storyboard) && <StoryboardDownloadRow downloadableMediaFile={storyboard} />}
    </SelectWrapper>
  );
};
